import React from 'react';

/**
 * Formats a phone number string to (xxx) xxx-xxxx format
 * @param value - The phone number string to format (can contain digits, spaces, dashes, parentheses)
 * @returns Formatted phone number string in (xxx) xxx-xxxx format
 */
export const formatPhoneNumber = (value: string): string => {
  // Remove all non-digit characters
  const onlyNums = value.replace(/\D/g, '');
  
  // Limit to 10 digits (US phone number)
  const digits = onlyNums.slice(0, 10);
  
  // Format based on length
  if (digits.length === 0) {
    return '';
  }
  if (digits.length <= 3) {
    return `(${digits}`;
  }
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

interface PhoneFormatterProps {
  /**
   * The phone number value to format and display
   */
  value: string;
  
  /**
   * Optional className for styling
   */
  className?: string;
  
  /**
   * Optional placeholder text if value is empty
   */
  placeholder?: string;
}

/**
 * Component that displays a phone number in (xxx) xxx-xxxx format
 */
export const PhoneFormatter: React.FC<PhoneFormatterProps> = ({
  value,
  className,
  placeholder = '',
}) => {
  const formattedValue = value ? formatPhoneNumber(value) : placeholder;
  
  return (
    <span className={className}>
      {formattedValue}
    </span>
  );
};

